import Image from "next/image";
import { cn } from "@/lib/utils";

interface HeritageBannerProps {
    title: string;
    subtitle: string;
    image: string;
    className?: string;
    textPosition?: "left" | "right" | "center";
}

export const HeritageBanner = ({
    title,
    subtitle,
    image,
    className,
    textPosition = "left",
}: HeritageBannerProps) => {
    return (
        <div className={cn("relative w-full rounded-3xl overflow-hidden min-h-100 flex items-center p-8 md:p-16", className)}>
            <div className="absolute inset-0 z-0">
                <Image
                    src={image}
                    alt={title}
                    fill
                    className="object-cover"
                />
                <div className="absolute inset-0 bg-black/40" />
            </div>

            <div className={cn(
                "relative z-10 w-full max-w-xl",
                textPosition === "center" && "mx-auto text-center",
                textPosition === "right" && "ml-auto text-right"
            )}>
                <h2 className="font-brastika text-4xl md:text-5xl text-white mb-6 leading-tight">
                    {title}
                </h2>
                <p className="text-white/90 text-lg leading-relaxed whitespace-pre-line">
                    {subtitle}
                </p>
            </div>
        </div>
    );
};
